import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  const appUrl = process.env.REACT_APP_EXTERNAL_APP_URL || 'https://aupairshare.base44.app';

  const handleAppRedirect = () => {
    window.open(appUrl, '_blank');
  };

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_flexible-families/artifacts/d41tdoag_my-project-page-1.png"
              alt="Au Pair Share"
              className="h-16 w-auto"
            />
            <p className="text-slate-400 leading-relaxed">
              Let us be your village. Flexible, trusted childcare when you need it.
            </p>
            <div className="flex items-center gap-2 text-slate-400">
              <MapPin className="w-4 h-4" />
              <span className="text-sm">Johannesburg • Pretoria • Cape Town • Durban</span>
            </div>
          </div>

          {/* For Families */}
          <div>
            <h3 className="text-white font-semibold mb-4">For Families</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/families" className="text-slate-400 hover:text-white transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/families" className="text-slate-400 hover:text-white transition-colors">
                  Booking Types
                </Link>
              </li>
              <li>
                <Link to="/safety" className="text-slate-400 hover:text-white transition-colors">
                  Safety & Trust
                </Link>
              </li>
              <li>
                <button onClick={handleAppRedirect} className="text-slate-400 hover:text-white transition-colors">
                  Start Booking
                </button>
              </li>
            </ul>
          </div>

          {/* For Au Pairs */}
          <div>
            <h3 className="text-white font-semibold mb-4">For Au Pairs</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/au-pairs" className="text-slate-400 hover:text-white transition-colors">
                  Become an Au Pair
                </Link>
              </li>
              <li>
                <Link to="/au-pairs" className="text-slate-400 hover:text-white transition-colors">
                  Requirements
                </Link>
              </li>
              <li>
                <Link to="/au-pairs" className="text-slate-400 hover:text-white transition-colors">
                  How to Apply
                </Link>
              </li>
              <li>
                <button onClick={handleAppRedirect} className="text-slate-400 hover:text-white transition-colors">
                  Apply Now
                </button>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/safety" className="text-slate-400 hover:text-white transition-colors">
                  Safety & Compliance
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-slate-400 hover:text-white transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-slate-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/popia" className="text-slate-400 hover:text-white transition-colors">
                  POPIA Statement
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
              <li className="pt-2">
                <a 
                  href="mailto:info@aupairshare.co.za" 
                  className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  <span>info@aupairshare.co.za</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} Au Pair Share. All rights reserved.
            </p>
            <div className="flex items-center gap-1 text-slate-400 text-sm">
              <span>Made with</span>
              <Heart className="w-4 h-4 fill-red-500 text-red-500" />
              <span>for families across South Africa</span>
            </div>
          </div>
        </div>

        {/* App Reminder */}
        <div className="mt-8 text-center">
          <p className="text-slate-500 text-sm">
            All bookings and matching happen in the app
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
